namespace GeniuzPOS.ReportMasterData {
    export interface Report_1318Form {
    }

    export class Report_1318Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1318';
    }
}
